<template>
  <BCard>
    <div class="flex items-start">
      <b-button
        variant="primary"
        size="sm"
        class="mr-1 rounded-lg p-0"
        @click="$router.go(-1)"
      >
        <feather-icon
          size="2x"
          icon="ChevronLeftIcon"
        />
      </b-button>
      <div class="text-black mb-2 text-2xl font-semibold">
        Packing List
      </div>
    </div>

    <div
      class="flex justify-end space-x-3"
    >
      <BButton
        variant="outline-primary"
        @click="$router.push({ name: 'detail-order-packing-non-komship', params: { id: $route.params.id } })"
      >
        Detail Order Packing
      </BButton>
      <!-- Download Button with spinner -->
      <BButton
        variant="primary"
        :disabled="loadingDownload"
        @click="downloadPackingList"
      >
        <b-spinner
          v-if="loadingDownload"
          small
          class="mr-1"
        />
        Download Packing List
      </BButton>
    </div>

    <BTable
      class="mt-6"
      :items="items"
      :fields="fields"
      :busy="loading"
      show-empty
      :empty-text="'Tidak ada data'"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle" />
          <strong>Loading...</strong>
        </div>
      </template>
    </BTable>
  </BCard>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'

export default {
  data() {
    return {
      loading: false,
      loadingDownload: false,
      items: [],

      fields: [
        { key: 'product_name', label: 'Produk', thClass: '!capitalize' },
        { key: 'qty', label: 'Qty', thClass: '!capitalize' },
      ],
    }
  },
  created() {
    this.getDetailPacking()
  },
  methods: {
    async getDetailPacking() {
      this.loading = true
      await newAxiosIns.get(`/kompack/api/v1/mitra/outbounds/${this.$route.params.id}/packing-list`)
        .then(res => {
          this.loading = false
          this.items = res.data.data
        }).catch(err => {
          console.log(err)
        })
    },

    async downloadPackingList() {
      this.loadingDownload = true
      try {
        const res = await newAxiosIns.get(`/kompack/api/v1/mitra/outbounds/${this.$route.params.id}/packing-list/print`, {
          responseType: 'blob',
        })
        this.loadingDownload = false

        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'packing-list.pdf')
        document.body.appendChild(link)
        link.click()

        window.URL.revokeObjectURL(url)
        link.remove()
      } catch (err) {
        console.log(err)
        this.loadingDownload = false
      }
    },
  },
}
</script>
